module.exports = __webpack_public_path__ + "611f6c40d5c09fe10a1658516cd2cd3c.svg";